module.exports = {
  languages: [
    {
      label: 'American English',
      value: 'en-us'
    },
    {
      label: 'Arabic (preview - modern standard Arabic)',
      value: 'ar-ar'
    },
    {
      label: 'Chinese',
      value: 'zh-cn'
    },
    {
      label: 'Dutch',
      value: 'nl-nl'
    },
    {
      label: 'French (France)',
      value: 'fr-fr'
    },
    {
      label: 'French (Canada)',
      value: 'fr-ca'
    },
    {
      label: 'German',
      value: 'de-de'
    },
    {
      label: 'Hindi',
      value: 'hi-in'
    },
    {
      label: 'Italian',
      value: 'it-it'
    },
    {
      label: 'Japanese',
      value: 'ja-jp'
    },
    {
      label: 'Korean',
      value: 'ko-kr'
    },
    {
      label: 'Portuguese (Brazil)',
      value: 'pt-br'
    },
    {
      label: 'Spanish (Spain)',
      value: 'es-es'
    },
    {
      label: 'Spanish (Mexico)',
      value: 'es-mx'
    },
    {
      label: 'Turkish',
      value: 'tr-tr'
    }
  ]
}
